export default function PricingLoader() {
  return (
    <div className="animate-pulse space-y-4 pt-4">
      <div className="flex flex-row justify-between">
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
      </div>
      <div className="flex flex-row justify-between">
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
      </div>
      <div className="flex flex-row justify-between pt-2">
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
        <div className="h-4 w-1/6 rounded bg-gray-200"></div>
      </div>
    </div>
  );
}
